import React from 'react';

import RejectField from '@features/supplier-onboarding/components/RejectField';

const ReadOnlySelect = ({ label, options = [], name, stepName, hideIcon = false }) => {
	const renderOptions = () => {
		return options?.map((item, i) => {
			return <span key={`select_${i}`}>{item.label}</span>;
		});
	};

	return (
		<div className="select-component chip-component form-group show">
			<label htmlFor={name}>{label}</label>
			<div className="click-box text-right click mb-1 dissable">
				<div className="all-chips">{renderOptions()}</div>
			</div>
			{!hideIcon && <RejectField name={name} stepName={stepName} />}
		</div>
	);
};

export default ReadOnlySelect;
